/**
 * HoverToggle Component
 */

import React from 'react';
import { HoverToggleProps } from './hoverToggle.types';
import { ElementHoverWrapper, ClassNameHoverWrapper } from './hoverToggle.style';

const HoverToggle = ({
  height = '100%',
  width = '100%',
  transitionSpeed = 0.3,
  hoverContent,
  hoverTransitionStyles = '',
  initTransitionStyles = '',
  classNameOverride = false,
  children,
}: HoverToggleProps) => {
  // Returns in plain div if no hoverContent is passed.
  if (!hoverContent && !classNameOverride) {
    return <div>{children}</div>;
  }
  const HoverWrapper = classNameOverride ? ClassNameHoverWrapper : ElementHoverWrapper;

  return (
    <HoverWrapper
      height={height}
      width={width}
      transitionSpeed={transitionSpeed}
      initTransitionStyles={initTransitionStyles}
      hoverTransitionStyles={hoverTransitionStyles}
    >
      {children}
      {!classNameOverride && hoverContent}
    </HoverWrapper>
  );
};

export enum HoverToggleResources {
  CLASSNAME = 'hover-toggle-data',
  CLASSNAME_HOVER_CONTENT = 'hover-content',
  CLASSNAME_HOVER_HIDDEN_CONTENT = 'hide-hover-content',
}

export default HoverToggle;
